import { cn } from 'lib/utils';
import { Input } from 'components/ui/input';

interface CurrencyInputProps {
  id: string;
  value: string;
  onChange: (v: string) => void;
  placeholder: string;
  disabled?: boolean;
}

export function CurrencyInput({
  id,
  value,
  onChange,
  placeholder,
  disabled = false,
}: CurrencyInputProps) {
  return (
    <div
      className={cn(
        'flex h-10 items-center border border-[var(--line-strong)] bg-[var(--input-bg)] transition-[border-color,box-shadow] focus-within:border-[var(--accent)] focus-within:ring-[3px] focus-within:ring-[var(--ring-color)]',
        disabled && 'cursor-not-allowed opacity-50',
      )}
    >
      <span className="select-none border-r border-[var(--line-strong)] px-3 text-sm text-[var(--text-muted)]">
        $
      </span>
      <Input
        id={id}
        type="number"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        step="0.01"
        min="0"
        disabled={disabled}
        className="h-full flex-1 border-0 bg-transparent px-3 focus-visible:ring-0"
      />
      <span className="select-none border-l border-[var(--line-strong)] px-3 text-sm text-[var(--text-muted)]">
        USD
      </span>
    </div>
  );
}
